import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from '@/components/LegalLayout';

const SECTIONS = [
  ['h_what', 'p_what'],
  ['h_categories', 'p_categories'],
  ['h_consent', 'p_consent'],
  ['h_manage', 'p_manage'],
  ['h_list', 'p_list'],
  ['h_contact', 'p_contact'],
];

export default function CookiePolicy({ lang }) {
  const { t } = useTranslation();
  return (
    <LegalLayout lang={lang} tKey="cookiepolicy">
      {SECTIONS.map(([h, p]) => (
        <section key={h} className="aq-legal__section">
          <h2>{t(`cookiepolicy.${h}`)}</h2>
          <p>{t(`cookiepolicy.${p}`)}</p>
        </section>
      ))}
    </LegalLayout>
  );
}
